import { render, staticRenderFns } from "./AssociatedGoodsComponent.vue?vue&type=template&id=52503f0f&scoped=true"
import script from "./AssociatedGoodsComponent.vue?vue&type=script&lang=js"
export * from "./AssociatedGoodsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52503f0f",
  null
  
)

export default component.exports